export default "__VITE_ASSET__BHxyfjIp__"